import React from 'react';
import { Mail, Phone, Youtube, Instagram, Facebook, Linkedin } from 'lucide-react';
const LOGO_URL = 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2FRedesigne%202024%2FMTDLarge%201.png&site=1856&w=191&h=108&user=1516&opt=w3';
export function Footer() {
  return <footer className="bg-black border-t border-brand-gray-800 pt-16 pb-8" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="grid grid-cols-1 md:grid-cols-[35%_1fr_auto] gap-12 mb-12" data-id="element-26">
          {/* Brand */}
          <div data-id="element-27">
            <a href="/" className="inline-block mb-6" data-id="element-28">
              <img src={LOGO_URL} alt="Medina Tactical Dynamics" className="block h-16 w-auto" data-id="element-29" />
            </a>
            <p className="text-brand-gray-400 max-w-md mb-6 text-sm leading-relaxed" data-id="element-30">
              Committed to providing our clients with highest quality of service
              combined with a strong sense of 360° situational awareness.
            </p>
            <div className="flex space-x-4" data-id="element-31">
              <a href="https://www.youtube.com/channel/UCWe8nIgfZn-Lhny4k-Wn3Wg" target="_blank" rel="noreferrer" aria-label="YouTube" className="text-brand-gray-500 hover:text-brand-teal transition-colors" data-id="element-32">
                <Youtube className="w-5 h-5" data-id="element-33" />
              </a>
              <a href="https://www.instagram.com/medinatactical360/" target="_blank" rel="noreferrer" aria-label="Instagram" className="text-brand-gray-500 hover:text-brand-teal transition-colors" data-id="element-34">
                <Instagram className="w-5 h-5" data-id="element-35" />
              </a>
              <a href="https://www.facebook.com/TeamAPCUSA/" target="_blank" rel="noreferrer" aria-label="Facebook" className="text-brand-gray-500 hover:text-brand-teal transition-colors" data-id="element-36">
                <Facebook className="w-5 h-5" data-id="element-37" />
              </a>
              <a href="https://www.linkedin.com/in/jose-medina-a84845a/" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="text-brand-gray-500 hover:text-brand-teal transition-colors" data-id="element-38">
                <Linkedin className="w-5 h-5" data-id="element-39" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div data-id="element-40">
            <h3 className="text-xs font-bold text-brand-white uppercase tracking-widest mb-6" data-id="element-41">
              Navigation
            </h3>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3" data-id="element-42">
              <li data-id="element-43">
                <a href="/law-enforcement-capabilities" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-44">
                  Law Enforcement
                </a>
              </li>
              <li data-id="element-45">
                <a href="/crisis-management-planning" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-46">
                  Crisis Planning
                </a>
              </li>
              <li data-id="element-47">
                <a href="/corporate-critical-incidents-planning" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-48">
                  Corporate
                </a>
              </li>
              <li data-id="element-49">
                <a href="/civilian-protection" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-50">
                  Civilian
                </a>
              </li>
              <li data-id="element-51">
                <a href="/training" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-52">
                  Training
                </a>
              </li>
              <li data-id="element-53">
                <a href="/strategic-partners" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-54">
                  Resources
                </a>
              </li>
              <li data-id="element-55">
                <a href="/blog" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-56">
                  Blog
                </a>
              </li>
              <li data-id="element-57">
                <a href="/medina-tactical-dynamics" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-58">
                  About
                </a>
              </li>
              <li data-id="element-59">
                <a href="/meet-the-founder" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-60">
                  Meet the Founder
                </a>
              </li>
              <li data-id="element-61">
                <a href="/contact" className="text-brand-gray-400 hover:text-brand-teal transition-colors text-sm" data-id="element-62">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-63">
            <h3 className="text-xs font-bold text-brand-white uppercase tracking-widest mb-6" data-id="element-64">
              Contact
            </h3>
            <ul className="space-y-4" data-id="element-65">
              <li data-id="element-66">
                <a href="tel:18666343373" className="flex items-center gap-3 text-brand-gray-400 hover:text-brand-teal transition-colors text-sm group" data-id="element-67">
                  <Phone className="w-4 h-4 text-brand-gray-600 group-hover:text-brand-teal flex-shrink-0" data-id="element-68" />
                  1-866-634-3373
                </a>
              </li>
              <li data-id="element-69">
                <a href="mailto:info@apc360zone.com" className="flex items-center gap-3 text-brand-gray-400 hover:text-brand-teal transition-colors text-sm group" data-id="element-70">
                  <Mail className="w-4 h-4 text-brand-gray-600 group-hover:text-brand-teal flex-shrink-0" data-id="element-71" />
                  info@apc360zone.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-brand-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-72">
          <p className="text-brand-gray-500 text-xs" data-id="element-73">
            &copy; {new Date().getFullYear()} Medina Tactical Dynamics / Team
            APC. All rights reserved.
          </p>
          <p className="text-brand-gray-600 text-xs" data-id="element-74">apc360zone.com</p>
        </div>
      </div>
    </footer>;
}